import { rankingData } from '@/mocks/homeData';

const rankColors = ['text-accent-500', 'text-secondary-500', 'text-primary-400', 'text-foreground-600', 'text-foreground-600'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            最受欢迎的动漫内容实时排行
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {/* Header */}
          <div className="hidden sm:grid grid-cols-12 gap-4 px-6 py-4 border-b border-background-200/60 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
            <div className="col-span-1">排名</div>
            <div className="col-span-5">作品名称</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-2">评分</div>
            <div className="col-span-2">热度</div>
          </div>

          {/* Items */}
          {rankingData.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="block sm:grid grid-cols-12 gap-4 px-4 sm:px-6 py-4 border-b border-background-200/40 last:border-b-0 hover:bg-background-200/30 cursor-pointer transition-colors"
            >
              {/* Rank */}
              <div className="col-span-1 flex items-center">
                <span className={`text-lg md:text-xl font-bold font-heading ${rankColors[item.rank - 1]}`}>
                  {item.rank <= 3 ? (
                    <i className={`${item.rank === 1 ? 'ri-medal-fill text-accent-500' : item.rank === 2 ? 'ri-medal-fill text-foreground-400' : 'ri-medal-fill text-amber-600'} text-xl`}></i>
                  ) : (
                    `0${item.rank}`
                  )}
                </span>
              </div>

              {/* Title */}
              <div className="col-span-5 flex items-center">
                <span className="text-sm md:text-base font-medium text-foreground-900 truncate">
                  {item.title}
                </span>
              </div>

              {/* Type */}
              <div className="col-span-2 flex items-center">
                <span className="text-xs text-foreground-600 bg-background-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.type}
                </span>
              </div>

              {/* Score */}
              <div className="col-span-2 flex items-center">
                <span className="text-sm font-semibold text-accent-600">{item.score}</span>
              </div>

              {/* Heat */}
              <div className="col-span-2 flex items-center">
                <span className="text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-fire-line text-primary-500 mr-1"></i>
                  {item.heat}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}